import axios from '@/utils/request'

export default {
  // 2020-07-27
  update(params) {
    return axios.put('/tenants', params)
  },

  // 2021-04-13
  clearBusinessData(params) {
    return axios.put('/tenants/clear-business-data', params)
  },
  // 2021-04-13
  applyClearDataVcode() {
    return axios.put('/tenants/apply-clear-data-v-code',)
  },

  // 2021-05-22
  updateYshopInfo(id, params) {
    return axios.put('/tenants/' + id + '/update-yshop-info', params)
  },

  // 2021-07-03
  updateMainProducts(id, params) {
    return axios.put('/tenants/' + id + '/update-main-products', params)
  },
  findById(id) {
    return axios.get('/tenants/' + id)
  }

}
